import axios from 'axios';
import { Stream, Task } from './types';

const API_BASE = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5001';

// Helper function to create axios instance with auth header
const createAuthAxios = (token: string | null) => {
  const headers: any = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  } else {
    // Fallback for development - use demo token
    headers.Authorization = 'Bearer demo-token';
  }
  
  return axios.create({
    baseURL: API_BASE,
    headers
  });
};

export const createApi = (token: string | null) => {
  const authAxios = createAuthAxios(token);
  
  return {
    // Streams
    getStreams: async (): Promise<Stream[]> => {
      const response = await authAxios.get('/api/streams');
      return response.data;
    },

    createStream: async (stream: Partial<Stream>): Promise<Stream> => {
      const response = await authAxios.post('/api/streams', stream);
      return response.data;
    },

    updateStream: async (id: string, stream: Partial<Stream>): Promise<Stream> => {
      const response = await authAxios.put(`/api/streams/${id}`, stream);
      return response.data;
    },

    deleteStream: async (id: string): Promise<{ message: string; deletedTaskCount: number }> => {
      const response = await authAxios.delete(`/api/streams/${id}`);
      return response.data;
    },

    // Tasks
    getTasks: async (): Promise<Task[]> => {
      const response = await authAxios.get('/api/tasks');
      return response.data;
    },

    createTask: async (task: Partial<Task>): Promise<Task> => {
      const response = await authAxios.post('/api/tasks', task);
      return response.data;
    },

    updateTask: async (id: string, task: Partial<Task>): Promise<Task> => {
      const response = await authAxios.put(`/api/tasks/${id}`, task);
      return response.data;
    },

    deleteTask: async (id: string): Promise<void> => {
      await authAxios.delete(`/api/tasks/${id}`);
    },

    clearDoneTasks: async (): Promise<void> => {
      await authAxios.delete('/api/tasks/done/clear');
    }
  };
};

// Legacy API for backward compatibility (will be removed)
export const api = createApi(null);